<template>
  <main id="main" class="main">
    <div class="pagetitle">
      <h1>SYSTEM IDENTITY SETTINGS</h1>
      <nav>
        <ol class="breadcrumb breadJa">
          <router-link :to="{ name: 'home' }" class="breadcrumb-item">Home</router-link>
          <router-link :to="{ name: 'system-identity' }" class="breadcrumb-item">Branding</router-link>
        </ol>
      </nav>
    </div>

    <section class="section profile">
      <div class="row">
        <div class="col-xl-4">
          <!-- Current Branding Card -->
          <div class="card shadow-sm border-0">
            <div class="card-body branding-sidebar-system pt-4">
              <div class="branding-previews-system">
                
                <h6 class="preview-section-title-system">Primary Branding</h6>
                <div class="text-center mb-4">
                  <div class="logo-preview-container-system mx-auto shadow-sm">
                    <img :src="getPreviewUrl('logo')" alt="Logo" class="logo-preview-img-system" @error="handleImageError">
                  </div>
                  <div class="company-info-system mt-3">
                    <h3>{{ form.company_name || 'Sudevwa' }}</h3>
                    <span class="badge bg-primary-light text-primary small fw-medium">Active Brand Identity</span>
                  </div>
                </div>

                <h6 class="preview-section-title-system">Visual Assets</h6>
                <div class="row g-3 mb-4">
                  <div class="col-6">
                    <div class="secondary-logo-container-system shadow-sm">
                      <img :src="getPreviewUrl('second_logo')" alt="Second Logo" class="logo-preview-img-system" @error="handleImageError">
                    </div>
                    <p class="text-center text-muted small mt-2 mb-0">Secondary</p>
                  </div>
                  <div class="col-6">
                    <div class="ico-container-system shadow-sm">
                      <img :src="getPreviewUrl('ico')" alt="Favicon" class="logo-preview-img-system" @error="handleImageError">
                    </div>
                    <p class="text-center text-muted small mt-2 mb-0">Browser Icon</p>
                  </div>
                </div>

                <h6 class="preview-section-title-system">Identity Overview</h6>
                <ul class="info-list-system">
                  <li class="info-item-system">
                    <div class="info-icon-system"><i class="bi bi-globe"></i></div>
                    <div class="info-content-system">
                      <span class="info-label-system">Website</span>
                      <span class="info-value-system">{{ form.company_website || '-' }}</span>
                    </div>
                  </li>
                  <li class="info-item-system">
                    <div class="info-icon-system"><i class="bi bi-envelope"></i></div>
                    <div class="info-content-system">
                      <span class="info-label-system">Email Support</span>
                      <span class="info-value-system">{{ form.company_email || '-' }}</span>
                    </div>
                  </li>
                  <li class="info-item-system">
                    <div class="info-icon-system"><i class="bi bi-telephone"></i></div>
                    <div class="info-content-system">
                      <span class="info-label-system">Contact Phone</span>
                      <span class="info-value-system">{{ form.company_phone || '-' }}</span>
                    </div>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8">
          <div class="card shadow-sm border-0">
            <div class="card-body pt-3">
              <ul class="nav nav-tabs nav-tabs-bordered nav-tabs-system">
                <li class="nav-item">
                  <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#branding-edit">Edit Branding</button>
                </li>
              </ul>

              <div class="tab-content pt-2">
                <div class="tab-pane fade show active" id="branding-edit">
                  <form @submit.prevent="handleSubmit" enctype="multipart/form-data" class="pt-3">
                    
                    <h5 class="card-title-system pt-0">Visual Assets</h5>
                    
                    <div class="row mb-4">
                      <div class="col-md-4 mb-3">
                        <label class="form-label fw-bold small text-uppercase">Logo Utama</label>
                        <div class="custom-file-upload-system">
                          <input type="file" ref="logoInput" class="d-none" @change="handleFileChange($event, 'logo')" accept="image/*">
                          <button type="button" class="btn-upload-system" @click="$refs.logoInput.click()">
                            <i class="bi bi-upload me-2"></i>Choose Logo
                          </button>
                          <div v-if="files.logo" class="file-name text-truncate mt-1 small text-success">
                            {{ files.logo.name }}
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 mb-3">
                        <label class="form-label fw-bold small text-uppercase">Logo Cadangan</label>
                        <div class="custom-file-upload-system">
                          <input type="file" ref="secondLogoInput" class="d-none" @change="handleFileChange($event, 'second_logo')" accept="image/*">
                          <button type="button" class="btn-upload-system" @click="$refs.secondLogoInput.click()">
                            <i class="bi bi-image me-2"></i>Choose Secondary
                          </button>
                          <div v-if="files.second_logo" class="file-name text-truncate mt-1 small text-success">
                            {{ files.second_logo.name }}
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 mb-3">
                        <label class="form-label fw-bold small text-uppercase">Favicon / Ikon Browser</label>
                        <div class="custom-file-upload-system">
                          <input type="file" ref="icoInput" class="d-none" @change="handleFileChange($event, 'ico')" accept="image/*,.ico">
                          <button type="button" class="btn-upload-system" @click="$refs.icoInput.click()">
                            <i class="bi bi-window-sidebar me-2"></i>Choose Icon
                          </button>
                          <div v-if="files.ico" class="file-name text-truncate mt-1 small text-success">
                            {{ files.ico.name }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <h5 class="card-title-system pt-0 border-top mt-2 pt-3">Company Details</h5>

                    <div class="row">
                      <div class="col-md-7">
                        <div class="form-group-system" :class="{ 'has-error': errors.company_name }">
                          <label for="company_name">Company Name</label>
                          <input v-model="form.company_name" type="text" id="company_name" placeholder="Enter full company name" @blur="validateField('company_name')">
                          <div v-if="errors.company_name" class="error-text-system">{{ errors.company_name }}</div>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="form-group-system" :class="{ 'has-error': errors.company_short_name }">
                          <label for="company_short_name">Short Name</label>
                          <input v-model="form.company_short_name" type="text" id="company_short_name" placeholder="e.g. SUDEV" @blur="validateField('company_short_name')">
                          <div v-if="errors.company_short_name" class="error-text-system">{{ errors.company_short_name }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group-system" :class="{ 'has-error': errors.company_description }">
                      <label for="company_description">Description</label>
                      <textarea v-model="form.company_description" id="company_description" placeholder="Describe your company..." @blur="validateField('company_description')"></textarea>
                      <div v-if="errors.company_description" class="error-text-system">{{ errors.company_description }}</div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group-system" :class="{ 'has-error': errors.company_address }">
                          <label for="company_address">Address</label>
                          <input v-model="form.company_address" type="text" id="company_address" placeholder="Enter address" @blur="validateField('company_address')">
                          <div v-if="errors.company_address" class="error-text-system">{{ errors.company_address }}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group-system" :class="{ 'has-error': errors.company_phone }">
                          <label for="company_phone">Phone</label>
                          <input v-model="form.company_phone" type="text" id="company_phone" placeholder="Enter phone number" @blur="validateField('company_phone')">
                          <div v-if="errors.company_phone" class="error-text-system">{{ errors.company_phone }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group-system" :class="{ 'has-error': errors.company_email }">
                          <label for="company_email">Email</label>
                          <input v-model="form.company_email" type="email" id="company_email" placeholder="Enter email" @blur="validateField('company_email')" @input="validateField('company_email')">
                          <div v-if="errors.company_email" class="error-text-system">{{ errors.company_email }}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group-system" :class="{ 'has-error': errors.company_website }">
                          <label for="company_website">Website</label>
                          <input v-model="form.company_website" type="text" id="company_website" placeholder="www.example.com" @blur="validateField('company_website')" @input="validateField('company_website')">
                          <div v-if="errors.company_website" class="error-text-system">{{ errors.company_website }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mt-4">
                      <button type="submit" class="btn-save-system shadow-sm" :disabled="isLoading">
                        <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                        <i v-else class="bi bi-check-lg me-2"></i>
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { getSystemIdentity, updateSystemIdentity } from '@/services/systemService';
import { useSystem } from '@/composables/useSystem.js';
import { showSuccess, showError } from '@/utils/toast';

export default {
  name: 'SystemIdentity',
  setup() {
    const { fetchSystemIdentity } = useSystem();
    const isLoading = ref(false);
    const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB
    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/x-icon', 'image/vnd.microsoft.icon'];
    
    const serverData = reactive({
      logo_url: '',
      ico_url: '',
      second_logo_url: ''
    });

    const form = reactive({
      company_name: '',
      company_short_name: '',
      company_description: '',
      company_address: '',
      company_phone: '',
      company_email: '',
      company_website: ''
    });

    const errors = reactive({
      company_name: '',
      company_short_name: '',
      company_description: '',
      company_address: '',
      company_phone: '',
      company_email: '',
      company_website: ''
    });

    const files = reactive({
      logo: null,
      ico: null,
      second_logo: null
    });

    const previews = reactive({
      logo: null,
      ico: null,
      second_logo: null
    });

    const fetchIdentity = async () => {
      try {
        const response = await getSystemIdentity();
        if (response.success && response.data) {
          const data = response.data;
          form.company_name = data.company_name || '';
          form.company_short_name = data.company_short_name || '';
          form.company_description = data.company_description || '';
          form.company_address = data.company_address || '';
          form.company_phone = data.company_phone || '';
          form.company_email = data.company_email || '';
          form.company_website = data.company_website || '';
          
          serverData.logo_url = data.logo_url || '';
          serverData.ico_url = data.ico_url || '';
          serverData.second_logo_url = data.second_logo_url || '';
        }
      } catch (error) {
        console.error('Error fetching identity:', error);
      }
    };

    const validateField = (field) => {
      errors[field] = '';
      
      const value = form[field];
      
      if (field === 'company_name' && !value) {
        errors.company_name = 'Company name is required';
      }

      if (field === 'company_short_name' && !value) {
        errors.company_short_name = 'Short name is required';
      }
      
      if (field === 'company_phone' && value) {
        const phoneRegex = /^[0-9+\-\s()]+$/;
        if (!phoneRegex.test(value)) {
          errors.company_phone = 'Invalid phone format (numbers only)';
        }
      }
      
      if (field === 'company_email' && value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          errors.company_email = 'Invalid email format';
        }
      }
      
      if (field === 'company_website' && value) {
        // Stricter regex: expects domain.tld (tld 2-6 chars) and optional subdomains
        const urlRegex = /^(https?:\/\/)?([\da-z-]+)\.([a-z]{2,6})(\.([a-z]{2,6}))?([\/\w .-]*)*\/?$/i;
        if (!urlRegex.test(value)) {
          errors.company_website = 'Invalid website format (e.g. sudevwa.com atau www.sudevwa.com)';
        }
      }
      
      return !errors[field];
    };

    const validateForm = () => {
      let isValid = true;
      Object.keys(form).forEach(key => {
        if (!validateField(key)) isValid = false;
      });
      return isValid;
    };

    const handleFileChange = (event, type) => {
      const file = event.target.files[0];
      if (file) {
        // Validation for file type
        if (!ALLOWED_TYPES.includes(file.type) && !file.name.endsWith('.ico')) {
          showError('Invalid file type. Please upload an image (JPG, PNG, WEBP, ICO).');
          event.target.value = '';
          return;
        }

        // Validation for file size
        if (file.size > MAX_FILE_SIZE) {
          showError('File size too large. Maximum size is 1MB.');
          event.target.value = '';
          return;
        }

        files[type] = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          previews[type] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    };

    const getPreviewUrl = (type) => {
      if (previews[type]) return previews[type];
      
      const baseUrl = process.env.VUE_APP_BE_APP_BASE_URL;
      const urlMap = {
        logo: serverData.logo_url,
        ico: serverData.ico_url,
        second_logo: serverData.second_logo_url
      };
      
      const path = urlMap[type];
      if (!path) return 'https://placehold.co/400x400?text=No+Logo';
      if (path.startsWith('http')) return path;
      return `${baseUrl}${path}?t=${new Date().getTime()}`;
    };

    const handleImageError = (e) => {
      e.target.src = 'https://placehold.co/400x400?text=Error+Loading';
    };

    const handleSubmit = async () => {
      if (!validateForm()) {
        showError('Please fix the errors in the form before submitting.');
        return;
      }

      isLoading.value = true;
      const formData = new FormData();
      
      // Add text fields
      Object.keys(form).forEach(key => {
        formData.append(key, form[key]);
      });
      
      // Add file fields
      if (files.logo) formData.append('logo', files.logo);
      if (files.ico) formData.append('ico', files.ico);
      if (files.second_logo) formData.append('second_logo', files.second_logo);

      try {
        const response = await updateSystemIdentity(formData);
        if (response.success) {
          showSuccess(response.message || 'System identity updated successfully');
          // Clear file selections and refresh previews from server urls
          files.logo = null;
          files.ico = null;
          files.second_logo = null;
          previews.logo = null;
          previews.ico = null;
          previews.second_logo = null;
          
          await fetchIdentity();
          // Trigger global update for Header/Sidebar
          await fetchSystemIdentity();
        } else {
          showError(response.message || 'Failed to update system identity');
        }
      } catch (error) {
        const msg = error.response?.data?.message || 'Error occurred while saving';
        showError(msg);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(fetchIdentity);

    return {
      form,
      errors,
      files,
      isLoading,
      handleFileChange,
      getPreviewUrl,
      handleImageError,
      handleSubmit,
      validateField
    };
  }
};
</script>

<style scoped>
/* Styles moved to public/assets/css/system-identity.css */
</style>
